import React from "react";
import DeliveredBy from "../../../Common/DeliveredBy";

const RestaurantBody = ({
  name,
  scrolled,
  types,
  minOrderEnabled,
  minOrderAmount,
  avgScore,
  commentsClassName,
  reviewCount,
  avgClassName,
  completedStatus,
  info,
  handleOpenInfo,
  handleClickReviews,
  deliveryType,
  onClickDeliveredBy
}) => (
  <div className="detail">
    <div className={` ${(scrolled && "container") || ""}`}>
      <h5>{name}</h5>

      <div className="d-flex justify-content-between align-items-center align-items-start-mobile">
        <div className="d-flex justify-content-start align-items-center flex-wrap-mobile">
          {minOrderEnabled && (
            <>
              <p>Min. £{parseFloat(minOrderAmount).toFixed(2)}</p>
              <p>|&nbsp;</p>
            </>
          )}
          <div className="d-flex align-items-center flex-wrap-mobile">
            {types.map(
              (type, i) =>
                (types.length !== i + 1 && (
                  <p key={i}>{`${type.name},`}&nbsp;</p>
                )) || <p key={i}>{type.name}</p>
            )}
          </div>
        </div>

        {(avgScore && (
          <React.Fragment>
            {(completedStatus && scrolled && (
              <span onClick={handleClickReviews} className="bold">
                Offline
              </span>
            )) || <noscript />}
            <div onClick={handleClickReviews} className={commentsClassName}>
              <span className="bold">{` ${reviewCount} `} Reviews</span>
              <span className={avgClassName}>{`${avgScore}`}</span>
            </div>
          </React.Fragment>
        )) || <noscript className={commentsClassName} />}
      </div>

      {(completedStatus && (
        <div
          className="opening-hours d-flex justify-content-between align-items-center visible-xs"
          onClick={handleOpenInfo}
        >
          <div className="d-flex align-items-center">
            <icon className="icon icon-clock" />
            <p>Opening Hours</p>
          </div>
        </div>
      )) ||
        (info && (
          <div className="opening-hours visible-xs" onClick={handleOpenInfo}>
            <p>{info.slice(0, 91)}...</p>
          </div>
        )) || <noscript /> || <noscript />}
      <DeliveredBy
        name={name}
        deliveryType={deliveryType}
        onClick={event => onClickDeliveredBy(event, name)}
      />
    </div>
  </div>
);

export default RestaurantBody;
